import _ from 'lodash';
import React, { Component, PropTypes } from 'react';
import { Col as BootstrapCol } from 'react-bootstrap';

/*
 * This class is a Frankly wrapper around bootstrap's column class. It extends bootstraps Col by allowing for custom
 * breakpoints to be added outside of the default xs, sm, md and lg.
 */
class Col extends Component {
  static propTypes = {
    spans: PropTypes.object,
    children: PropTypes.node,
    className: PropTypes.string
  }

  render() {
    const { spans = {}, children, className = '' } = this.props;
    const defaultSpans = _.pick(spans, ['xs', 'sm', 'md', 'lg']);
    const customSpans = _.omit(spans, ['xs', 'sm', 'md', 'lg']);

    let classNames = className;

    _.forOwn(customSpans, (val, key) => {
      classNames += ` col-${key}-${val}`;
    });

    return (
      <BootstrapCol {...defaultSpans} className={classNames.trim()} >
        {children}
      </BootstrapCol>
    );
  }
}

export default Col;



// WEBPACK FOOTER //
// ./app/components/core/Col.js